import React from 'react';
import { RefreshUniversal } from '@duxton-web/icons';
import { Button, Timeline } from '@duxton-web/ui';

import ChangelogItem from './ChangelogItem/ChangelogItem';
import { Rollout } from '@/lib/PlannerDTOs';

interface OwnProps {
  latestRollout: Rollout;
  changelogs: any[];
  onRestore?: (rollout: Rollout) => void;
  includeUnchanged?: boolean;
}

export default function ChangelogIndividual({
  changelogs,
  latestRollout,
  onRestore,
  includeUnchanged,
}: OwnProps) {
  const items = changelogs?.map((item) => {
    return {
      children: (
        <div
          style={{
            marginLeft: 8,
          }}
        >
          <ChangelogItem
            latestRollout={latestRollout}
            changelog={item}
            onRestore={onRestore}
            includeUnchanged={includeUnchanged}
          />
        </div>
      ),
      dot: (
        <Button
          disabled
          size="small"
          shape="circle"
          style={{
            backgroundColor: '#FFF',
            border: '1px solid #3D3D3D',
          }}
          icon={
            <RefreshUniversal
              style={{
                color: '#1A1A1A',
              }}
            />
          }
        />
      ),
      position: 'right',
    };
  });

  return (
    <Timeline
      className="changelog-all"
      style={{
        flexGrow: 1,
        overflow: 'hidden auto',
        paddingTop: '4px',
        padding: '4px 16px 0 16px',
        paddingInlineStart: '24px',
      }}
      mode="left"
      items={items}
    />
  );
}
